export const IMG_CONSTANTS={
    PLANNED: 'assets/route-replay/planned.svg',
    SIGNIN: 'assets/route-replay/signin.svg',
    SIGN_OUT: 'assets/route-replay/sign-out.svg',
    SIGN_IN:"assets/route-replay/sign-in.svg",
    NO_SHOW: 'assets/route-replay/noshow.svg',
    START_LOCATION: 'assets/route-replay/startlocation.svg',
    RIGHT_ARROW: 'assets/route-replay/right-arrow.svg',
    EXPAND_ARROW: 'assets/route-replay/expand-arrow.svg',
    CAPACITY: 'assets/route-replay/capacity.svg',
    BOARDED: 'assets/route-replay/boarded.svg',
    SPARE_SEATS: 'assets/route-replay/spareseats.svg',
    TRIP_START: 'assets/route-replay/trip-start.svg',
    TRIP_END: 'assets/route-replay/trip-end.svg',
};